var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 4.9H8.98L8.62 7.1H10.96L10.72 8.54H8.38L7.8 12H6.28L6.86 8.54H4.42L3.84 12H2.3L2.88 8.54H0.56L0.8 7.1H3.12L3.48 4.9H1.14L1.38 3.44H3.72L4.3 -7.15256e-07H5.84L5.26 3.44H7.7L8.28 -7.15256e-07H9.8L9.22 3.44H11.54L11.3 4.9ZM7.1 7.1L7.46 4.9H5.02L4.66 7.1H7.1Z",
    fill: "#2B3D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.ce7259bf37f0f7c9cf0664fcb3ba042d.svg";
export { ForwardRef as ReactComponent };